import styled from '@emotion/styled'

import { spacing } from '@cash-design-system/react'

export const NestedCard = styled.div<{ padding?: keyof typeof spacing }>`
  border: 0.125rem solid ${props => props.theme.colors.nestedCardOutline};
  border-radius: 0.75rem;

  padding: ${({ padding }) => (padding ? spacing[padding] : spacing.insetM)};
`
